import type { SessionUser, TenantSummary } from '@levitas/contracts';

/**
 * Para onde alguém vai depois de entrar.
 *
 * Quem é da equipe da El Shaday e não pertence a igreja nenhuma tem o
 * backoffice como casa — mandá-la para "escolher a igreja" seria oferecer uma
 * lista vazia. E é essa ausência de vínculo que faz da impersonação auditada o
 * único caminho para dentro de uma conta.
 */
export function destinoDeEntrada(
  usuario: Pick<SessionUser, 'isPlatformUser'> | null,
  igreja: TenantSummary | null,
): string {
  if (igreja) return '/inicio';
  if (usuario?.isPlatformUser) return '/backoffice';
  return '/escolher-igreja';
}
